<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.JobNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.fk_cu_id ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.fk_cu_id ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            <b-button v-if="$sessionsStorage.get('designation') == 'Admin'" class="mr-2 btn-sm" variant="primary"
              @click="clearPortExpense" :disabled="getPaymentList.length <= 0">

              <span v-if="!isClearPortExpenseProcessing">Clear Port Expense</span>
              <span v-else>
                <b-spinner small class="mr-2"></b-spinner>
                Processing...
              </span>
            </b-button>
            <b-form-group class="pull-right ml-1 mt-1">
              <b-button variant="primary" class="d-flex align-items-center" size="sm" style="font-size: 0.675rem"
                @click="triggerFileInput">
                <md-icon class="md-size-1x nav-icon mr-2">cloud_upload</md-icon>

                <div v-if="isFileLoading" class="d-flex align-items-center">
                  <span class="mr-2">Uploading...</span>
                  <b-spinner small></b-spinner>
                </div>
                <div v-else class="d-flex align-items-center">
                  Upload File
                </div>
              </b-button>
              <input ref="fileInput" type="file" class="d-none" @change="handleFileUpload" accept=".xlsx, .xls" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)" />
            </div>
          </b-col>

          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Container No Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container NO Filter"
              id="ContainerNoFilter" name="ContainerNoFilter" autocomplete="off" v-model="Filter.ContainerNoFilter"
              @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Common Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter" id="commonFilter"
              name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
              @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
          </b-col>


        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>

                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale"
                    @update="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container NO Filter"
                    id="ContainerNoFilter" name="ContainerNoFilter" autocomplete="off"
                    v-model="Filter.ContainerNoFilter" @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Bill Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Shipping Bill Filter"
                    id="ShippingBillFilter" name="ShippingBillFilter" autocomplete="off"
                    v-model="Filter.ShippingBillFilter" @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container Size Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container Size Filter"
                    id="ContSizeFilter" name="ContSizeFilter" autocomplete="off" v-model="Filter.ContSizeFilter"
                    @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Approved By</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Approved By Filter"
                    id="approvedBy" name="approvedBy" autocomplete="off" v-model="Filter.approvedBy"
                    @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Emp Name</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Emp Name Filter"
                    id="empNameFilter" name="empNameFilter" autocomplete="off" v-model="Filter.empNameFilter"
                    @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>


                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Created User
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="fk_cu_id"
                    @input="getBulkPortExpenseList('Normal', '0', '0', '1', '1')" v-model="Filter.fk_cu_id"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">

            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">

                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)" />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal id="confirm-bulk-port-expense" ref="confirm-bulk-port-expense" title="Confirm Port Expense" size="xl"
      no-close-on-esc no-close-on-backdrop hide-footer>

      <b-row>
        <b-col cols="12">
          <h4 class="mt-3 error" v-if="errMSG && selectedRows.length > 0">{{ errMSG }} </h4>
          <ExcelViewer v-if="selectedRows.length > 0" :fileUrl="excelFileUrl" />

        </b-col>

        <b-col md="12" v-if="selectedRows.length > 0">
          <b-table :items="selectedRows" :fields="confirmFields" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.index + 1 }}</span></template>
            <template slot="pe_container_no" slot-scope="row1">
              <span>{{ row1.item.pe_container_no }}</span><br />
              <span class="error">{{ row1.item.validationResult.MSG }}</span>
            </template>
          </b-table>
        </b-col>

        <b-col md="12" class=" mt-2" v-if="selectedRows.length > 0">
          <b-button class="mr-2 btn-sm" variant="primary" @click="getSlineImportData">
            <!-- :disabled="selectedRows.length <= 0 || invalidContainersList.length > 0" -->

            <span v-if="!isBulkPortExpenseProcessing">Bulk Port Expense</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing...
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
            Cancel
          </b-button>
        </b-col>

      </b-row>

      <!-- You could also include item details here if needed -->
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-confirm :md-title="alert.title" :md-content="alert.content" :md-ok-text="alert.ok"
      @close="onConfirmClearPort" ref="confirmClearPort"></md-dialog-confirm>


  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus, GlobalContainerValid } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import PortExpenseService from "../../services/PortExpenseService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { read, utils, writeFile } from "xlsx";
import axios from "axios";
import ExcelViewer from "../childComponent/ExcelViewer.vue";


export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),

    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getPaymentList: [],
      totalData: 0,

      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],

      validate: true,

      dateFormat: { year: "numeric", month: "short", day: "numeric" },
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'pe_shipping_bill', label: 'Shipping Bill' },
        { key: 'pe_emp_name', label: 'Emp Name' },
        { key: 'pe_cont_size', label: 'Cont Size' },
        { key: 'pe_container_no', label: 'Container NO' },
        { key: 'pe_cc_fix', label: 'CC Fix' },
        { key: 'pe_loading_unloading', label: 'Loading Unloading' },
        { key: 'pe_seal_cutting', label: 'Seal Cutting' },
        { key: 'pe_examination', label: 'Examination' },
        { key: 'pe_marking', label: 'Marking' },
        { key: 'pe_measurement', label: 'Measurment' },
        { key: 'pe_other', label: 'Other' },
        { key: 'pe_approved_by', label: 'Approved BY' },
        { key: 'pe_remarks', label: 'Remarks' },
      ],

      isBulkPortExpenseProcessing: false,
      isClearPortExpenseProcessing: false,
      selectedRows: [],
      excelFileUrl: URL_BASE_DOC + "/ASSIGNMENT_UPLOADS/Master_Port_Expense_module/",
      PaymentFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "pe_shipping_bill",
          mainkey: "pe_shipping_bill",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_container_no",
          mainkey: "pe_container_no",
          label: "Container NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Linked Job NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ContainerNos",
          mainkey: "ContainerNos",
          label: "Linked Container NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_cont_size",
          mainkey: "pe_cont_size",
          label: "Cont Size",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_emp_name",
          mainkey: "pe_emp_name",
          label: "Emp Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_cc_fix",
          mainkey: "pe_cc_fix",
          label: "CC Fix",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_loading_unloading",
          mainkey: "pe_loading_unloading",
          label: "Loading Unloading",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_seal_cutting",
          mainkey: "pe_seal_cutting",
          label: "Seal Cutting",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_examination",
          mainkey: "pe_examination",
          label: "Examination",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_marking",
          mainkey: "pe_marking",
          label: "Marking",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_measurement",
          mainkey: "pe_measurement",
          label: "Measurment",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_other",
          mainkey: "pe_other",
          label: "Other",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_remarks",
          mainkey: "pe_remarks",
          label: "Remarks",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pe_approved_by",
          mainkey: "pe_approved_by",
          label: "Approved BY",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      statusList: [
        {
          pTypeVal: "0",
          pTypeText: "In-Active",
        },
        {
          pTypeVal: "1",
          pTypeText: "Active",
        },
        {
          pTypeVal: "2",
          pTypeText: "All",
        },
      ],

      Filter: {
        ContainerNoFilter: "",
        ShippingBillFilter: "",
        ContSizeFilter: "",
        approvedBy: "",
        empNameFilter: "",
        commonFilter: "",
        fk_cu_id: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      isSubmited: false,
      isFileLoading: false,

      files: [], // ✅ make sure this is here
      fileData: null,
      presignedUrls: [],
      uploadedFiles: [],
      fileuploaded: '',
      fileEvent: '',
      validContainerNo: null,
      algoConNo: "",
      invalidContainersList: [],
      confirm: {
        title: "Confirmation",
        content: "Are you sure you want to clear all port expenses?",
        ok: "Yes",
        cancel: "No"
      },
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    ExcelViewer,
  },
  computed: {
    // If number of selected rows = total rows in getPaymentList
  },
  watch: {},
  methods: {
    checkForComma(containerNo) {
      return containerNo.includes(",");
    },

    getConAlgoList(containerNo) {
      if (containerNo !== "") {
        this.validContainerNo = GlobalContainerValid(containerNo);
      }
    },

    containerNoRegexfun(containerNo) {
      this.getConAlgoList(containerNo);
      this.algoConNo = this.validContainerNo;

      const containerformat = /^[a-zA-Z]{4}[0-9]{7}$/;

      // Split by comma in case multiple containers are passed in string
      const containerArray = this.algoConNo.split(',').map(c => c.trim()).filter(c => c);

      // Find invalid containers
      const invalidContainers = containerArray.filter(container => !containerformat.test(container));

      // Save to validationResult and also to a separate list
      this.validationResult = {
        valid: invalidContainers.length === 0,
        invalidContainers: invalidContainers,
        MSG: invalidContainers.length == 0 ? '' : 'Invalid Container Formate Pls Correct!'
      };

      // 🆕 Custom array
      return this.validationResult;
    },

    getFormatDateTime() {
      // Parse the originalDateTime string into a JavaScript Date object
      // Set originalDateTime to the current date and time
      let originalDateTime = new Date();

      // Extract individual components (optional)
      const year = originalDateTime.getFullYear();
      const month = originalDateTime.getMonth() + 1; // January is 0
      const day = originalDateTime.getDate();
      const hour = originalDateTime.getHours();
      const minute = originalDateTime.getMinutes();

      // Format the date and time as "YYYYMMDDHHmm"
      const formattedDateTime = `${year}${month
        .toString()
        .padStart(2, "0")}${day.toString().padStart(2, "0")}${hour
          .toString()
          .padStart(2, "0")}${minute.toString().padStart(2, "0")}`;

      // Display the formatted date and time
      return formattedDateTime;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      const fileList = event.target.files;
      if (!fileList.length) return;
      // Initialize file records
      for (let i = 0; i < fileList.length; i++) {
        this.files.push({
          name: fileList[i].name,
          progress: 0,
          file: fileList[i],
        });
      }

      const formData = new FormData();
      const userId = this.$sessionsStorage.get("loginId");

      // Append form data
      this.files.forEach((fileObj, index) => {
        formData.append("file[]", fileObj.file);
        formData.append(
          "staticFileName",
          `${fileObj.name}_FileLength_${this.files.length}_${index}_${this.getFormatDateTime()}`
        );
      });

      // Add folder and user ID to track who uploaded
      formData.append(
        "upload_dir_folderName", "Master_Port_Expense_module"
      );
      formData.append("userId", userId);

      try {
        const response = await axios.post(
          `${URL_BASE}/uploadFileCommonForAllTest31_05_2024.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: userId,
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              this.files.forEach((fileObj) => (fileObj.progress = progress));
            },
          }
        );

        this.fileData = response.data;
        this.presignedUrls = response.data.presignedUrlArr || [];
        this.uploadedFiles = this.fileData.imgPath.split(",") || [];
        this.fileuploaded = this.fileData.imgPath;
        // this.excelFileUrl = this.excelFileUrl + this.fileuploaded;
        this.getSignedDocumentUrl(`ASSIGNMENT_UPLOADS/Master_Port_Expense_module/${this.fileuploaded}`).then(url => {
          if (url) {
            this.excelFileUrl = url;
          }
        });
        this.fileEvent = "";

        // Proceed with S3 upload
        await this.uploadFiles();
      } catch (error) {
        console.error("Upload error:", error);
        setTimeout(() => {
          this.handleFileChange(this.fileEvent);
        }, 10000);
      }

      // Excel Parsing
      const file = fileList[0];
      if (!file) return;

      this.parseExcelFile(file);
    },


    parseExcelFile(file) {
      const reader = new FileReader();
      this.isFileLoading = true;

      reader.onload = (e) => {
        const workbook = read(e.target.result, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
        // Now parse the data
        const parsedData = this.parseExcelData(jsonData);
        this.selectedRows = parsedData;
        this.openConfirmModal();
        this.isFileLoading = false;
      };

      reader.onerror = (error) => {
        console.error("File reading error:", error);
        this.isFileLoading = false;
      };

      reader.readAsBinaryString(file);
    },

    parseExcelData(rawData) {
      if (!Array.isArray(rawData) || rawData.length < 2) {
        return [];
      }

      const headers = rawData[0].map(header => header.trim());
      const rows = rawData.slice(1);

      const result = rows
        .filter(row => row && row.length > 0 && row.some(cell => cell !== undefined && cell !== null && cell !== ''))
        .map(row => {
          const obj = {};

          headers.forEach((header, index) => {
            const value = row[index];

            switch (header) {
              case "Shipping Bill":
                obj.pe_shipping_bill = value ? value.toString() : '' || null;
                break;
              case "Emp Name":
                obj.pe_emp_name = value ? value.toString() : '' || null;
                break;
              case "Cont Size":
                obj.pe_cont_size = value ? value.toString() : '' || null;
                break;
              case "Container NO":
                obj.pe_container_no = value ? value.toString() : '' || null;
                break;
              case "CC Fix":
                obj.pe_cc_fix = value !== undefined ? parseFloat(value) : null;
                break;
              case "Loading Unloading":
                obj.pe_loading_unloading = value !== undefined ? parseFloat(value) : null;
                break;
              case "Seal Cutting":
                obj.pe_seal_cutting = value !== undefined ? parseFloat(value) : null;
                break;
              case "Examination":
                obj.pe_examination = value !== undefined ? parseFloat(value) : null;
                break;
              case "Marking":
                obj.pe_marking = value !== undefined ? parseFloat(value) : null;
                break;
              case "Measurment":
                obj.pe_measurement = value !== undefined ? parseFloat(value) : null;
                break;
              case "Other":
                obj.pe_other = value !== undefined ? parseFloat(value) : null;
                break;
              case "Approved BY":
                obj.pe_approved_by = value ? value.toString() : '' || null;
                break;
              case "Remarks":
                obj.pe_remarks = value ? value.toString() : '' || null;
                break;
              default:
                break;
            }
          });
          if (obj.pe_container_no && typeof obj.pe_container_no === 'string' && obj.pe_container_no.trim() !== '') {
            obj.validationResult = this.containerNoRegexfun(obj.pe_container_no);
            if (!obj.validationResult.valid) {
              this.invalidContainersList.push(obj);
            }
          } else {
            obj.validationResult = { valid: false, reason: 'Empty or invalid container number' };
            this.invalidContainersList.push(obj);
          }

          // obj.validationResult = this.containerNoRegexfun(obj.pe_container_no);
          if (!obj.validationResult.valid) {
            this.invalidContainersList.push(obj);
          }
          return obj;
        });

      return result;
    },

    async uploadFiles() {
      try {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i].file;
          const presignedUrl = this.presignedUrls[i];
          if (presignedUrl) {
            await this.uploadFileToS3(file, presignedUrl, i);
          }
        }
      } catch (error) {
        console.error("Error uploading files to S3:", error);
      }
    },

    uploadFileToS3(file, presignedUrl, index) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100;
            this.files[index].progress = Math.round(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
          } else {
            reject(`Upload failed with status ${xhr.status}`);
          }
        };

        xhr.onerror = () => reject("Upload failed due to network error.");

        xhr.send(file);
      });
    },
    clearPortExpense() {
      if (this.getPaymentList.length > 0) {
        this.$refs.confirmClearPort.open(); // just open — no `.then()`
      } else {
        console.log("Please choose at least one valid Port Expense.");
      }
    },

    onConfirmClearPort(type) {

      if (this.getPaymentList.length > 0) {
        if (type == "ok") {
          this.isClearPortExpenseProcessing = true;
          PortExpenseService.clearPortExpense({})
            .then((response) => {
              const { data, status, statusText } = response;
              if (status == 200 && data) {
                this.isClearPortExpenseProcessing = false;
                this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Catch on clearPortExpense Error: ", error);
            });
        } else {
          console.log("Clear Port Expense cancelled by user.");
        }
      } else {
        console.log("Please Choose Atleast One Correct Port Expense List ");
      }
    },

    getSlineImportData() {
      this.errMSG = "";
      let payload = { excel_data: this.selectedRows, pel_doc_url: this.fileuploaded, pel_doc_name: this.fileuploaded, };
      if (this.selectedRows.length > 0) {
        this.isBulkPortExpenseProcessing = true;
        PortExpenseService.upsertExcelBulkPortExp(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (response.data && response.data.error) {
              this.alert.content = response.data.error;
              this.$refs["addPop"].open();
            }

            if (status == 200 && data) {
              this.isBulkPortExpenseProcessing = false;
              this.selectedRows = [];
              this.resetModal();
              this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getSlineImportData Error: ", error);
          });
      } else {
        console.log("PLease Choose Atleast One Correct Ledger List ");
      }
    },

    openConfirmModal() {
      this.$refs["confirm-bulk-port-expense"].show();
    },
    resetModal() {
      // Reset state each time modal is closed
      this.selectedRows = [];
      this.errMSG = "";
      this.$refs["confirm-bulk-port-expense"].hide();
    },

    clearFilter() {
      this.Filter = {
        ContainerNoFilter: "",
        ShippingBillFilter: "",
        ContSizeFilter: "",
        approvedBy: "",
        empNameFilter: "",
        commonFilter: "",
        fk_cu_id: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate, // 11/02/2025
        endDate: endDate,     // 12/02/2025
      };
    },

    getBulkPortExpenseList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        linkedExp:localStorage.getItem("linkedExp")
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      PortExpenseService.getAllPortExpenseList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Port-Expense-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.total;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.meta.total;
                this.pagination.currentPage = data.meta.currentPage;
                this.pagination.perPage = data.meta.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBulkPortExpenseList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBulkPortExpenseList("Excell", "0", "0", "1", "1");
    },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkPortExpenseList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkPortExpenseList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>


// WEBPACK FOOTER //
// portExpenseUpload.vue?572977bd